import { AffiliatePartners } from "./affiliate-partners";

export const REDIRECT_HOSTS = {
  [AffiliatePartners.BOOKING_COM]: "sp.booking.com",
  [AffiliatePartners.EXPEDIA]: "prf.hn",
  busbud: "www.busbud.com"
};
